import { CircularProgress, styled } from '@mui/material'
import { VersionReportVersionEntity } from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { Button } from '../../../../components/buttons'
import moment from 'moment'
import { colorPalette } from '../../../../style/colorPalette'
import {
  LoadingContainer,
  TableContainer,
  TableHeader,
  TableBody,
  TableRow,
  HeaderCell,
  DataCell,
  DialogHeader,
  DialogContent,
  DialogTitle,
  HeaderButtons,
} from './commons'
import { CloseButton, StyledDivider } from '../commons'

interface ReportMenuProps {
  templateName: string
  reports: VersionReportVersionEntity[]
  loading: boolean
  onReportSelect: (report: VersionReportVersionEntity) => void
  onBackToTemplate: () => void
  onCreateNewReport: () => void
  onClose: () => void
}

export const ReportMenu = ({
  templateName,
  reports,
  loading,
  onReportSelect,
  onBackToTemplate,
  onCreateNewReport,
  onClose,
}: ReportMenuProps) => {
  return (
    <>
      <DialogHeader>
        <DialogTitle>{templateName}</DialogTitle>
        <HeaderButtons>
          <Button
            colorPattern="monotone"
            variant="outlined"
            onClick={onBackToTemplate}
            size="s"
          >
            戻る
          </Button>
          <CloseButton onClick={onClose} />
        </HeaderButtons>
      </DialogHeader>
      <StyledDivider />
      <ReportListHeader>
        <ReportListTitle>報告書一覧</ReportListTitle>
        <Button size="s" variant="outlined" onClick={onCreateNewReport}>
          新しく報告書を作成
        </Button>
      </ReportListHeader>
      <StyledDivider />
      <DialogContent>
        {loading ? (
          <LoadingContainer>
            <CircularProgress />
          </LoadingContainer>
        ) : (
          <TableContainer>
            <TableHeader>
              <HeaderCell width="45%">名称</HeaderCell>
              <HeaderCell width="30%">更新者</HeaderCell>
              <HeaderCell width="25%">更新日時</HeaderCell>
            </TableHeader>
            <TableBody>
              {reports.map(report => (
                <TableRow
                  key={report.uuid}
                  onClick={() => onReportSelect(report)}
                >
                  <DataCell width="45%">{report.name}</DataCell>
                  <DataCell width="30%">{report.updatedBy.name}</DataCell>
                  <DataCell width="25%">
                    {moment(report.updatedAt).format('MM/DD HH:mm')}
                  </DataCell>
                </TableRow>
              ))}
            </TableBody>
          </TableContainer>
        )}
      </DialogContent>
    </>
  )
}

const ReportListHeader = styled('div')({
  padding: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

const ReportListTitle = styled('h3')({
  margin: 0,
  fontSize: '14px',
  fontWeight: 600,
  color: colorPalette.monotone[10],
})
